import React from 'react'
import ContentHome from '../components/organisms/contentHome/contentHome'
import useMediaQuery from './../shared/utils/useMediaQuery'
import PageLayout from '../components/templates/page-layout/page-layout'
import UseValidateView from '../utils/useValidateView'

function IndexPage() {
  const isMobile = useMediaQuery()

  const [isSession] = UseValidateView()


  return (

    <PageLayout mobile={isMobile} isLogged={isSession}>
      <ContentHome isMobile={isMobile} isLogged={isSession}/>
    </PageLayout>
  )
}

export default IndexPage
